module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"validate":"Validate"},"es":{"validate":"Validar"},"sw":{"validate":"Thibitisha"}}')
  delete Component.options._Ctor
}
